import styled from "styled-components";

export const ListStages = styled.div`
  height: 100%;
  box-sizing: border-box;
  .status-list {
    padding: 20px 20px 0;
    display: flex;
    flex-direction: column;
    overflow: auto;
    height: 100%;
    box-sizing: border-box;
    .status-empty {
      display: flex;
      height: 100%;
    }
    .status-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 10px 10px 7px 10px;
      min-width: 250px;
      border-radius: 5px;
      &__button {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 20px;
        padding: 10px;
        width: 100%;
        background-color: #edebf7;
        font-family: Nunito Sans;
        font-size: 17px;
        color: #1f1f52;
        text-align: center;
        outline: none;
        border: none;
        cursor: pointer;
        &--selected {
          color: #1168ff;
          font-family: Nunito Sans bold;
        }
        &--current {
          background-color: #edebf7;
          color: #6c6bf5;
          font-family: Nunito Sans bold;
        }
        &--disabled {
          background-color: #edebf7;
          cursor: default;
          color: #707582;
          opacity: 0.45;
        }
      }
      &__left {
        display: flex;
        align-items: center;
      }
      &__text {
      }
      &__counter {
        display: flex;
        align-items: center;
        margin-left: 10px;
        height: 24px;
        .counter {
          &__button {
            color: #1f1f52;
            cursor: pointer;
            background: #fff;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            font-size: 13px;
            justify-content: center;
          }
          &__number {
            margin: 7px;
          }
        }
      }
      &__radio-button {
        border-radius: 50%;
        width: 20px;
        height: 20px;
        border: 1.2px solid #2a28d6;
        background-color: #ffffff;
        padding: 3px;
        box-sizing: border-box;
        display: flex;
        margin-right: 5px;
        &-content {
          width: 14px;
          border-radius: 50%;
          background-color: #1168ff;
        }
      }
      &__caption {
        font-size: 11px;
        color: #707582;
        font-family: Nunito Sans;
        font-size: 13px;
        height: 16px;
        &--selected {
          color: #6c6bf5;
        }
      }
    }
  }
`;
